export default __webpack_public_path__ + "static/media/kyc-verified.551e085d.png";